/* @ts-ignore */
import Glide, {Swipe, Controls, Breakpoints, Autoplay} from "@glidejs/glide/dist/glide.modular.esm";

const doc = document;
const HEROSLIDER_CLASS = '.heroslider';
const CONTENTTEAMSLIDER_CLASS = '.contentslider__team';
const CONTENTNEWSSLIDER_CLASS = '.contentslider__news';
const CONTENTREFERENCESSLIDER_CLASS = '.contentslider__references';
const ARROW_CLASS = '.glide__arrows';
const AUTOPLAY_SEC = 4000;

export default class Slider  {

  constructor(type: string) {
    switch (type) {
        case 'heroslider': this.renderHeroslider(this); break;
        case 'teamslider':this.renderTeamslider(this); break;
        case 'referencesslider':this.renderReferenceslider(this); break;
        case 'contentslider': this.renderContentslider(this); break;
    }
  }

  renderHeroslider(slider: Slider) {

    if(doc.querySelector(HEROSLIDER_CLASS) != null){
        // console.info('Found Heroslider => start render heroslider.');
        new Glide(HEROSLIDER_CLASS, {
            type: 'slider',
            autoplay: AUTOPLAY_SEC
        }).mount({ Swipe, Controls, Breakpoints, Autoplay });

        if(document.querySelectorAll(HEROSLIDER_CLASS + ' li').length < 2) {
            let arrowNode = <HTMLElement>document.querySelector(ARROW_CLASS);
            arrowNode.style.display = 'none';
        }
    }
  }

  renderContentslider(slider: Slider) {
    if(doc.querySelector(CONTENTNEWSSLIDER_CLASS)){
      // console.info('Found Contentslider => start render Contentslider.');
      new Glide(CONTENTNEWSSLIDER_CLASS, {
          type: 'slider',
          //autoplay: AUTOPLAY_SEC,
          startAt: 0,
          perView: 2,
          rewind: false,
          breakpoints: {
            560: { perView: 1, peek: {before: 0, after: 50} },
            820: { perView: 2, peek: {before: 0, after: 70} },
            1024: { perView: 3 }
          },

      }).mount({ Swipe, Controls, Breakpoints, Autoplay });

    }
  }

  renderTeamslider(slider: Slider) {
    if(doc.querySelector(CONTENTTEAMSLIDER_CLASS)){
      // console.info('Found Teamslider => start render Teamslider.');
      new Glide(CONTENTTEAMSLIDER_CLASS, {
          type: 'slider',
          //autoplay: AUTOPLAY_SEC,
          startAt: 0,
          perView: 3,
          rewind: false,
          peek: {before: 0, after: 120},
          breakpoints: {
            560: { perView: 1, peek: {before: 0, after: 50} },
            768: { perView: 2, peek: {before: 0, after: 50} },
            1024: { perView: 3, peek: {before: 0, after: 50} }
          },

      }).mount({ Swipe, Controls, Breakpoints, Autoplay });

    }
  }

  renderReferenceslider(slider: Slider) {
    if(doc.querySelector(CONTENTREFERENCESSLIDER_CLASS)){
      // console.info('Found Teamslider => start render Teamslider.');
      new Glide(CONTENTREFERENCESSLIDER_CLASS, {
 type: 'slider',
          //autoplay: AUTOPLAY_SEC,
          startAt: 0,
          perView: 2,
          rewind: false,
          breakpoints: {
            560: { perView: 1, peek: {before: 0, after: 50} },
            820: { perView: 2, peek: {before: 0, after: 70} },
            1024: { perView: 2 }
          },

      }).mount({ Swipe, Controls, Breakpoints, Autoplay });

    }
  }


}